/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useState } from 'react'
import { useIntl } from 'react-intl'
import { KTSVG } from '../../../_metronic/helpers'
import { GuideListModal } from './_modals/GuideListModal'
import { GuideFormModal } from './_modals/GuideFormModal'
import { DeleteModal } from '../../components/modals/DeleteModal'
import GuideApi from '../../../infrastructure/api/GuideApi'
import { Link, Route, Switch } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { useSelector, shallowEqual } from 'react-redux'
import { RootState } from '../../../setup'
import { checkPermission, UserModel } from '../../modules/auth/models/UserModel'
import { PermissionEnum } from '../../../enums/PermissionEnum'

const GuidePage: FC = () => {
  const [itemId, setItemId] = useState(0)
  const [itemName, setItemName] = useState('')

  const [showDelete, setShowDelete] = useState(false)
  const handleCloseDelete = () => setShowDelete(false)
  const handleShowDelete = () => setShowDelete(true)

  const [refresh, setRefresh] = useState<number>(0)
  const [showForm, setShowForm] = useState(false)
  const handleCloseForm = () => { setShowForm(false); setRefresh(refresh + 1) }
  const handleShowForm = () => setShowForm(true)

  const user: UserModel = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel

  const onClickItem = (value: number, name: string, type: string) => {
    setItemId(value)
    setItemName(name)
    switch (type) {
      case 'delete':
        handleShowDelete()
        break
      default:
        handleShowForm()
        break
    }
  }

  const guidesBreadCrumbs: Array<PageLink> = [
    {
      title: '',
      path: '',
      isSeparator: false,
      isActive: false,
    },
  ]
  const guideBreadCrumbs: Array<PageLink> = [
    {
      title: 'Guides',
      path: `/guides`,
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]

  async function deleteGuide(itemId: number) {
    var response = await GuideApi.DeleteGuide(itemId)
    setRefresh(refresh + 1)
  }

  return (
    <>
      <div className='card mb-5 mb-xl-8'>

        <Switch>
          <Route path={['/guides/edit/:id', '/guides/add']}>
            <PageTitle breadcrumbs={guideBreadCrumbs}>Guide</PageTitle>
            <GuideFormModal itemId={itemId} show={showForm} handleClose={handleCloseForm} />
          </Route>
          <Route path='/guides'>
            <PageTitle breadcrumbs={guidesBreadCrumbs}>Guides</PageTitle>
            <div className='card-header border-0 pt-5'>
              <h3 className='card-title align-items-start flex-column'>
              </h3>
              {checkPermission(user, PermissionEnum.GuideCreate) &&
                <div
                  className='card-toolbar'
                  data-bs-toggle='tooltip'
                  data-bs-placement='top'
                  data-bs-trigger='hover'
                  title='Click to add a Guide'
                >

                  <Link
                    to={'/guides/add'}
                    className='btn btn-sm btn-light-primary'
                  >
                    <KTSVG
                      path='/media/icons/duotone/Code/Plus.svg'
                      className='svg-icon-3'
                    />
                    Add Guide
                  </Link>
                </div>
              }
            </div>

            <div className='card-body py-3'>
              <GuideListModal refresh={refresh} onClickItem={onClickItem} />
              <DeleteModal
                itemId={itemId}
                itemName={itemName}
                handleClose={handleCloseDelete}
                show={showDelete}
                type='Guide'
                confirm={deleteGuide}
              />
            </div>
          </Route>
        </Switch>
      </div>
    </>
  )
}

const GuideWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>Guide</PageTitle>
      <GuidePage />
    </>
  )
}

export { GuideWrapper }
